import React from 'react';
import classnames from 'classnames';
import { Spin } from 'antd';
import styles from './index.module.less';

const Loading = (props): JSX.Element => {
  const { className = '' } = props;
  return (
    <div className={classnames(styles.loadingContainer, className)}>
      <Spin size="large" />
    </div>
  );
};

export default Loading;
